package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_05_30_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes inspect the field of force. Four fist-sized cones seem to be powering the field with a switch/button inside. Four vials of anti-toxin are sitting nearby — possibly the vials purchased at Cordon’s Commerce General Store in Gudin by Tressa and Delia.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Tuesday throws a flower into the field, and it instantly vaporizes.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Tuesday tries to Misty Step through but fails, taking necrotic damage.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Dirk tries to dispel the field, but that also fails.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper wants to yank on all four field emitters. The heroes yank on them with about 30 lbs of force and are poisoned, but the field does shutdown. The heroes use the anti-toxins. The shard of The Shield of Concar is the mirror image of the shard from The Greatmarsh. Dirk adds the shard to his bag of holding.")
    }
}
